import { useCallback, useState } from 'react';

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import IconButton from '@mui/material/IconButton';

import { isBrokerOrFlexpert } from '../../helpers/roles/isBrokerOrFlexpert';
import useCounter from '../../hooks/Couters';
import BrokerHelpList from '../common/Accordion/AccordianHelp';
import ProviderHelpList from '../common/Accordion/Accordion';
import PopupModal from '../common/PopupModal/PopupModal';

export const NavHelpMenuV2 = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { helpViewCounter } = useCounter();

  const toggleModal = useCallback(
    (e) => {
      setModalIsOpen((prev) => !prev);
      helpViewCounter(e);
    },
    [helpViewCounter],
  );

  const closeModal = useCallback(() => {
    setModalIsOpen(false);
  }, []);

  return (
    <>
      <IconButton onClick={toggleModal}>
        <HelpOutlineIcon />
      </IconButton>
      {modalIsOpen && (
        <PopupModal open={modalIsOpen} onClose={closeModal}>
          {isBrokerOrFlexpert() ? <BrokerHelpList /> : <ProviderHelpList />}
        </PopupModal>
      )}
    </>
  );
};
